module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Light.c69f8fbfc36c0650c14e5b2534e59818.ttf";